import { RingBuffer as SERVICE_WORKER_RingBuffer } from '../../../../ServiceWorker/src/helpers/ring-buffer';

export { SERVICE_WORKER_RingBuffer as RingBuffer };
